/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRoleRequestDto
 */
export interface UpdateRoleRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequestDto
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateRoleRequestDto interface.
 */
export function instanceOfUpdateRoleRequestDto(value: object): value is UpdateRoleRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateRoleRequestDtoFromJSON(json: any): UpdateRoleRequestDto {
    return UpdateRoleRequestDtoFromJSONTyped(json, false);
}

export function UpdateRoleRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoleRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateRoleRequestDtoToJSON(json: any): UpdateRoleRequestDto {
    return UpdateRoleRequestDtoToJSONTyped(json, false);
}

export function UpdateRoleRequestDtoToJSONTyped(value?: UpdateRoleRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

